/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CalibrationsReportDtoDlmBaseResponse } from '../models/calibrations-report-dto-dlm-base-response';
import { Status } from '../models/status';

@Injectable({
  providedIn: 'root',
})
export class CalibrationsReportService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiCalibrationsReportDataGet
   */
  static readonly ApiCalibrationsReportDataGetPath = '/api/CalibrationsReport/data';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationsReportDataGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationsReportDataGet$Plain$Response(params?: {
    fromDate?: string;
    toDate?: string;

    /**
     * 0 &#x3D; BookedIn
     * 
     * 1 &#x3D; InCalibration
     * 
     * 2 &#x3D; CalReportComplete
     * 
     * 3 &#x3D; AwaitingClientResponse
     * 
     * 4 &#x3D; AwaitingRepair
     * 
     * 5 &#x3D; Completed
     * 
     * 6 &#x3D; Dispatched
     * 
     * 7 &#x3D; ReadyForDispatch
     * 
     * 8 &#x3D; SalesToProductionHandover
     * 
     * 9 &#x3D; GenericInspectionThirdParty
     */
    status?: Status;
  }): Observable<StrictHttpResponse<CalibrationsReportDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationsReportService.ApiCalibrationsReportDataGetPath, 'get');
    if (params) {
      rb.query('fromDate', params.fromDate, {});
      rb.query('toDate', params.toDate, {});
      rb.query('status', params.status, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CalibrationsReportDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationsReportDataGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationsReportDataGet$Plain(params?: {
    fromDate?: string;
    toDate?: string;

    /**
     * 0 &#x3D; BookedIn
     * 
     * 1 &#x3D; InCalibration
     * 
     * 2 &#x3D; CalReportComplete
     * 
     * 3 &#x3D; AwaitingClientResponse
     * 
     * 4 &#x3D; AwaitingRepair
     * 
     * 5 &#x3D; Completed
     * 
     * 6 &#x3D; Dispatched
     * 
     * 7 &#x3D; ReadyForDispatch
     * 
     * 8 &#x3D; SalesToProductionHandover
     * 
     * 9 &#x3D; GenericInspectionThirdParty
     */
    status?: Status;
  }): Observable<CalibrationsReportDtoDlmBaseResponse> {

    return this.apiCalibrationsReportDataGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CalibrationsReportDtoDlmBaseResponse>) => r.body as CalibrationsReportDtoDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationsReportDataGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationsReportDataGet$Json$Response(params?: {
    fromDate?: string;
    toDate?: string;

    /**
     * 0 &#x3D; BookedIn
     * 
     * 1 &#x3D; InCalibration
     * 
     * 2 &#x3D; CalReportComplete
     * 
     * 3 &#x3D; AwaitingClientResponse
     * 
     * 4 &#x3D; AwaitingRepair
     * 
     * 5 &#x3D; Completed
     * 
     * 6 &#x3D; Dispatched
     * 
     * 7 &#x3D; ReadyForDispatch
     * 
     * 8 &#x3D; SalesToProductionHandover
     * 
     * 9 &#x3D; GenericInspectionThirdParty
     */
    status?: Status;
  }): Observable<StrictHttpResponse<CalibrationsReportDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationsReportService.ApiCalibrationsReportDataGetPath, 'get');
    if (params) {
      rb.query('fromDate', params.fromDate, {});
      rb.query('toDate', params.toDate, {});
      rb.query('status', params.status, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CalibrationsReportDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationsReportDataGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationsReportDataGet$Json(params?: {
    fromDate?: string;
    toDate?: string;

    /**
     * 0 &#x3D; BookedIn
     * 
     * 1 &#x3D; InCalibration
     * 
     * 2 &#x3D; CalReportComplete
     * 
     * 3 &#x3D; AwaitingClientResponse
     * 
     * 4 &#x3D; AwaitingRepair
     * 
     * 5 &#x3D; Completed
     * 
     * 6 &#x3D; Dispatched
     * 
     * 7 &#x3D; ReadyForDispatch
     * 
     * 8 &#x3D; SalesToProductionHandover
     * 
     * 9 &#x3D; GenericInspectionThirdParty
     */
    status?: Status;
  }): Observable<CalibrationsReportDtoDlmBaseResponse> {

    return this.apiCalibrationsReportDataGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CalibrationsReportDtoDlmBaseResponse>) => r.body as CalibrationsReportDtoDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCalibrationsReportExportCsvGet
   */
  static readonly ApiCalibrationsReportExportCsvGetPath = '/api/CalibrationsReport/export/csv';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCalibrationsReportExportCsvGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationsReportExportCsvGet$Response(params?: {
    fromDate?: string;
    toDate?: string;

    /**
     * 0 &#x3D; BookedIn
     * 
     * 1 &#x3D; InCalibration
     * 
     * 2 &#x3D; CalReportComplete
     * 
     * 3 &#x3D; AwaitingClientResponse
     * 
     * 4 &#x3D; AwaitingRepair
     * 
     * 5 &#x3D; Completed
     * 
     * 6 &#x3D; Dispatched
     * 
     * 7 &#x3D; ReadyForDispatch
     * 
     * 8 &#x3D; SalesToProductionHandover
     * 
     * 9 &#x3D; GenericInspectionThirdParty
     */
    status?: Status;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, CalibrationsReportService.ApiCalibrationsReportExportCsvGetPath, 'get');
    if (params) {
      rb.query('fromDate', params.fromDate, {});
      rb.query('toDate', params.toDate, {});
      rb.query('status', params.status, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCalibrationsReportExportCsvGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCalibrationsReportExportCsvGet(params?: {
    fromDate?: string;
    toDate?: string;

    /**
     * 0 &#x3D; BookedIn
     * 
     * 1 &#x3D; InCalibration
     * 
     * 2 &#x3D; CalReportComplete
     * 
     * 3 &#x3D; AwaitingClientResponse
     * 
     * 4 &#x3D; AwaitingRepair
     * 
     * 5 &#x3D; Completed
     * 
     * 6 &#x3D; Dispatched
     * 
     * 7 &#x3D; ReadyForDispatch
     * 
     * 8 &#x3D; SalesToProductionHandover
     * 
     * 9 &#x3D; GenericInspectionThirdParty
     */
    status?: Status;
  }): Observable<string> {

    return this.apiCalibrationsReportExportCsvGet$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

}
